// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i5-6";
export var emphasizeQuantity = "_i5-3";
export var flatBottomCorners = "_i5-5";
export var productImage = "_i5-0";
export var quantityContainer = "_i5-2";
export var tooltip = "_i5-1";
export var wrapAndEllipsesOverflow = "_i5-4";